var api = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/mini-css-extract-plugin/dist/loader.js!../../node_modules/string-replace-loader/index.js??ref--7-2!../../node_modules/css-loader/dist/cjs.js?-url!../../node_modules/postcss-loader/src/index.js??ref--7-4!../../node_modules/sass-loader/dist/cjs.js!./theme.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};